(function () {
  var controls = document.querySelector('[data-catalog-controls]');
  if (!controls) return;

  var VIEW_STORAGE_KEY = 'cowalkies:catalog-view';
  var activeCategory = '';
  // Populated by setUpSortDropdown, read by swapSortedResults — module-scoped so the fetch
  // handler can re-sync the trigger label/selected option from its own response without either
  // function needing to know about the other's internals.
  var sortCurrentLabelEl = null;
  var sortOptionEls = null;
  var sortAnimateLabelFn = null;

  setUpCategoryFilter();
  setUpSortDropdown();
  setUpViewToggle();

  // Client-side, not a real Dawn facet: every product already renders into the grid (this
  // collection isn't expected to run into pagination at the scale this filter is meant for),
  // so toggling visibility + recounting locally is simpler and faster than a server round-trip.
  // If pagination ever does kick in, this only filters what's on the current page — a known
  // limit of doing it this way, not a bug. Re-runs itself after every sort swap (see
  // applyStateToResults below) since a fresh server-rendered grid always comes back unfiltered.
  function setUpCategoryFilter() {
    var pillWrap = document.querySelector('[data-category-pills]');
    if (!pillWrap) return;
    var pills = pillWrap.querySelectorAll('[data-category-value]');

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (p) {
          p.classList.toggle('is-active', p === pill);
        });
        activeCategory = pill.getAttribute('data-category-value');
        animateFilterChange(activeCategory);
      });
    });
  }

  // Same dim-through-the-swap treatment the sort re-render already uses
  // (.ai-catalog__results-*.is-loading, see the section stylesheet and swapSortedResults below) —
  // reused here rather than a second bespoke animation system, so filtering and sorting read as
  // the same kind of "results are updating" moment instead of two different ones. Identical
  // timing too: dim fully over the rule's own 400ms, swap the hidden/shown state while fully
  // obscured, then clear immediately so the same 400ms transition plays in reverse.
  function animateFilterChange(category) {
    var results = document.querySelector('[data-catalog-results]');
    var grid = document.getElementById('product-grid');
    if (!grid) return;

    if (!results || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      applyFilter(grid, category);
      return;
    }

    results.classList.add('is-loading');
    window.setTimeout(function () {
      applyFilter(grid, category);
      results.classList.remove('is-loading');
    }, 400);
  }

  function applyFilter(grid, category) {
    var countEl = document.querySelector('[data-product-count]');
    if (!grid) return;
    var items = grid.querySelectorAll('.grid__item');
    var visibleCount = 0;
    items.forEach(function (item) {
      var matches = category === '' || item.getAttribute('data-product-type') === category;
      item.hidden = !matches;
      if (matches) visibleCount += 1;
    });
    if (countEl) countEl.textContent = visibleCount + ' ' + (visibleCount === 1 ? (countEl.getAttribute('data-label-one') || 'product') : (countEl.getAttribute('data-label-other') || 'products'));
  }

  // Expands in place (grid-template-rows, matching the catalog card's own size/color picker and
  // the site's accordion pattern) rather than opening Dawn's whole-screen drawer for what's a
  // 4–6 item list. Picking an option used to do a full page navigation for a guaranteed-correct
  // server-side re-sort; it now fetches just this section's re-rendered HTML and blends the new
  // card order into the grid already on screen (see swapSortedResults) — the label/selected-state
  // update instantly since the outcome is already known client-side, no need to wait on the
  // network for that part.
  function setUpSortDropdown() {
    var dropdown = document.querySelector('[data-sort-dropdown]');
    if (!dropdown) return;

    var trigger = dropdown.querySelector('[data-sort-trigger]');
    var currentLabel = dropdown.querySelector('[data-sort-current]');
    var options = dropdown.querySelectorAll('[data-sort-value]');
    sortCurrentLabelEl = currentLabel;
    sortOptionEls = options;
    sortAnimateLabelFn = animateSortLabel;

    function close() {
      dropdown.classList.remove('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }

    function toggle() {
      var isOpen = dropdown.classList.toggle('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    if (trigger) trigger.addEventListener('click', function (e) { e.stopPropagation(); toggle(); });

    function selectOption(option) {
      options.forEach(function (o) {
        o.classList.toggle('is-selected', o === option);
      });
      animateSortLabel(option.getAttribute('data-sort-name') || option.textContent.trim());
    }

    // Text-swap (blur + fade, not an instant pop) + the trigger's own width tweening to match —
    // transitions-dev's motion-token catalog tags exactly this pairing (a label's text changing
    // in place) with --duration-quick (150ms) / an ease-in-out curve, distinct from both the
    // spring-overshoot press feedback and --expand-ease's panel-fold rhythm used elsewhere on this
    // page — a third, correctly-scoped category, not a reach for whichever curve happened to be
    // nearby. The width tween needs real before/after pixel values (WAAPI, like the FLIP reshape
    // above) since animating to/from an implicit "auto" width isn't reliably animatable — trigger
    // has no explicit width normally, so its natural size *is* the before/after here.
    function animateSortLabel(newText) {
      if (!currentLabel) return;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion || !trigger || typeof currentLabel.animate !== 'function') {
        currentLabel.textContent = newText;
        return;
      }

      var firstWidth = trigger.getBoundingClientRect().width;
      var textOut = currentLabel.animate([{ opacity: 1, filter: 'blur(0)' }, { opacity: 0, filter: 'blur(2px)' }], {
        duration: 150,
        easing: 'ease-in-out',
      });

      textOut.finished
        .then(function () {
          currentLabel.textContent = newText;
          var lastWidth = trigger.getBoundingClientRect().width;

          if (Math.abs(lastWidth - firstWidth) > 0.5 && typeof trigger.animate === 'function') {
            trigger.animate([{ width: firstWidth + 'px' }, { width: lastWidth + 'px' }], {
              duration: 150,
              easing: 'ease-in-out',
            });
          }

          currentLabel.animate([{ opacity: 0, filter: 'blur(2px)' }, { opacity: 1, filter: 'blur(0)' }], {
            duration: 150,
            easing: 'ease-in-out',
          });
        })
        .catch(function () {
          currentLabel.textContent = newText;
        });
    }

    options.forEach(function (option) {
      option.addEventListener('click', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', option.getAttribute('data-sort-value'));

        selectOption(option);
        close();

        window.history.pushState({}, '', url.toString());
        swapSortedResults(url.toString());
      });
    });

    // Back/forward only replays the URL change pushState made above — nothing re-syncs the
    // visible sort label or card order to match unless something listens for it, so the label
    // would otherwise sit on whatever was last clicked while the address bar (and a reload)
    // disagree. No client-side URL-param matching here (a bare /collections/all with no sort_by
    // at all — the very first entry in history — has no option to match against): swapSortedResults
    // reads the trigger label straight out of its own fetch response, which is always correct
    // since that's the server's own resolved default/selected sort for the URL, not a guess.
    window.addEventListener('popstate', function () {
      close();
      swapSortedResults(window.location.href);
    });

    document.addEventListener('click', function (e) { if (!dropdown.contains(e.target)) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  // Fetches this section's own re-rendered HTML for the new URL (Shopify's standard
  // ?section_id= section-rendering endpoint — no app or custom API needed) and swaps in just the
  // reordered cards, instead of a full page reload. The existing cards dim + soften in place
  // while the fetch is in flight (CSS on .ai-catalog__results-*.is-loading) rather than being
  // replaced by generic skeleton placeholders — they're already the right shape, so blurring the
  // real content is both simpler and more honest about what's about to change (the order) versus
  // what isn't (the products themselves, their images, their count).
  function swapSortedResults(url) {
    var results = document.querySelector('[data-catalog-results]');
    var sectionHost = document.querySelector('collection-component');
    var sectionId = sectionHost && sectionHost.getAttribute('data-section-id');

    // No known section id, or this markup predates the results wrapper (older cached HTML) —
    // fall back to a real navigation rather than silently doing nothing.
    if (!results || !sectionId) {
      window.location.href = url;
      return;
    }

    results.classList.add('is-loading');
    var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sectionId;

    fetch(fetchUrl)
      .then(function (response) {
        if (!response.ok) throw new Error('sort fetch failed');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newResults = doc.querySelector('[data-catalog-results]');
        if (!newResults) throw new Error('missing results in response');

        // The fetched response's own trigger label/selected option is the server's actual
        // resolved sort for this URL — authoritative for both paths that call this function
        // (a click already set these optimistically to the same value; popstate has no better
        // source, since a bare URL with no sort_by at all has nothing for it to match against).
        syncSortLabelFrom(doc);

        // Let the dim-out transition actually finish before swapping the DOM underneath it —
        // matches this rule's own 0.4s duration so the motion reads as one continuous fade
        // through, not a cut in the middle of it.
        window.setTimeout(function () {
          results.innerHTML = newResults.innerHTML;
          applyStateToResults(results);
          results.classList.remove('is-loading');
        }, 400);
      })
      .catch(function () {
        window.location.href = url;
      });
  }

  function syncSortLabelFrom(doc) {
    if (!sortOptionEls) return;
    var fetchedSelected = doc.querySelector('[data-sort-value].is-selected');
    var fetchedLabel = doc.querySelector('[data-sort-current]');
    var value = fetchedSelected && fetchedSelected.getAttribute('data-sort-value');
    if (value == null) return;
    sortOptionEls.forEach(function (o) {
      o.classList.toggle('is-selected', o.getAttribute('data-sort-value') === value);
    });
    // A same-tab click already animated the label optimistically (selectOption, above) before
    // this fetch confirmation even lands — re-animating the *same* text here would just replay
    // the swap a beat later for no visible change. Only popstate (browser back/forward, which
    // never calls selectOption at all) actually needs this path to animate anything.
    if (sortCurrentLabelEl && fetchedLabel) {
      var newText = fetchedLabel.textContent;
      if (sortCurrentLabelEl.textContent.trim() !== newText.trim() && sortAnimateLabelFn) {
        sortAnimateLabelFn(newText);
      } else if (sortCurrentLabelEl.textContent.trim() !== newText.trim()) {
        sortCurrentLabelEl.textContent = newText;
      }
    }
  }

  // A freshly fetched grid comes back from the server unfiltered and with no client-only state —
  // re-wire the new cards' own behavior (buy button, variant picker, media dots, notify form) and
  // re-apply whatever the shopper had already chosen (active category, single/double view) so the
  // swap doesn't quietly reset choices that have nothing to do with sort order.
  function applyStateToResults(results) {
    if (window.CowalkiesCatalog && window.CowalkiesCatalog.initCards) {
      window.CowalkiesCatalog.initCards(results);
    }
    var grid = results.querySelector('#product-grid');
    applyFilter(grid, activeCategory);
    if (grid) applyColumnClasses(grid, getDefaultView());

    // The discarded cards' own scroll-focus listeners (each card opts in via
    // data-scroll-focus="page" — see animations.js) would otherwise leak: a plain innerHTML swap
    // doesn't fire any cleanup on its own. resetListeners() cancels every one of them — including
    // the still-present, not-being-replaced controls row's own listener — then
    // initializePageScrollFocus() re-scans the whole document and re-establishes a fresh one for
    // everything currently in the DOM, controls row included. Same pattern
    // assets/page-transitions.js uses for a full page swap, just triggered by a section swap here.
    if (window.CowalkiesAnimations) window.CowalkiesAnimations.resetListeners();
    if (typeof initializePageScrollFocus === 'function') initializePageScrollFocus();
  }

  // The saved density is remembered per breakpoint: the same 'single'/'double' word means 2-vs-3
  // columns on desktop but 1-vs-2 on phones, so one shared value made a choice on one device class
  // silently reshape the other (a "1 card" pick on a phone would show 2 columns on desktop). Each
  // starts from its own default — desktop 3 cards, mobile 1 card — until the shopper picks.
  function viewStorageKey() {
    return VIEW_STORAGE_KEY + (isDesktopWidth() ? ':desktop' : ':mobile');
  }

  function getSavedView() {
    try {
      return localStorage.getItem(viewStorageKey());
    } catch (e) {
      return null;
    }
  }

  // Dawn's own desktop grid-column classes only take effect from 990px up (see base.css) — using
  // any other number here would leave a dead zone between this and Dawn's real breakpoint where
  // a class got swapped but nothing visually changed.
  var DESKTOP_BREAKPOINT_PX = 990;
  var DESKTOP_COL_CLASSES = ['grid--2-col-desktop', 'grid--3-col-desktop', 'grid--4-col-desktop', 'grid--5-col-desktop', 'grid--6-col-desktop'];

  // window.innerWidth, not window.matchMedia(...).matches — a plain dimension read has one fewer
  // layer (no separate media-query engine/cache to independently settle) between "what the
  // viewport actually is" and what this function sees. See the requestAnimationFrame re-check
  // right after this function's first call site (in setUpViewToggle, below) for why a single
  // point-in-time read here — of either kind — still isn't trusted on its own at page-load.
  function isDesktopWidth() {
    return window.innerWidth >= DESKTOP_BREAKPOINT_PX;
  }

  // No saved preference yet: default to 'double' (configured columns) on desktop, unchanged, but
  // 'single' (1 column) on mobile/tablet — a 2-up grid reads cramped at phone width as the first
  // thing a shopper sees, before they've had a chance to reach for the toggle themselves.
  function getDefaultView() {
    var saved = getSavedView();
    if (saved === 'single' || saved === 'double') return saved;
    return isDesktopWidth() ? 'double' : 'single';
  }

  // The view toggle means something different depending on viewport, by design: on mobile/
  // tablet it's still the original 1-vs-configured-columns choice (is-single-col, unchanged);
  // on desktop it's 2-vs-3 columns specifically (rhode's own catalog uses exactly this pattern —
  // see the design-system skill), which fully supersedes the section's own columns_desktop
  // setting there rather than layering on top of it. 'single'/'double' stay the two state names
  // in both cases — think "fewer" / "more" rather than literal counts, since the same state means
  // a different number at each breakpoint. Reusing Dawn's own grid--2-col-desktop/grid--3-col-
  // desktop classes for the desktop case (rather than hand-writing width math) means the desktop
  // columns get exactly Dawn's already-correct, already-tested sizing for free.
  function applyColumnClasses(grid, view) {
    if (isDesktopWidth()) {
      grid.classList.remove('is-single-col');
      DESKTOP_COL_CLASSES.forEach(function (c) {
        grid.classList.remove(c);
      });
      grid.classList.add(view === 'single' ? 'grid--2-col-desktop' : 'grid--3-col-desktop');
    } else {
      grid.classList.toggle('is-single-col', view === 'single');
    }
  }

  // View density toggle (1 vs configured columns on mobile/tablet; 2 vs 3 columns on desktop —
  // see applyColumnClasses) — a pure client-side preference (localStorage), so it's built once
  // here rather than authored in Liquid, and re-applied to each freshly swapped-in grid by
  // applyStateToResults above rather than rebuilt.
  function aiStr(key, fallback) {
    return (window.aiStrings && window.aiStrings[key]) || fallback;
  }

  function setUpViewToggle() {
    var countEl = document.querySelector('[data-product-count]');
    if (!countEl || !countEl.parentElement) return;

    var toggle = document.createElement('div');
    toggle.className = 'ai-view-toggle';
    toggle.innerHTML =
      '<button type="button" class="ai-view-toggle__btn" data-view="single" aria-label="' + aiStr('fewerPerRow', 'Show fewer products per row') + '">' +
      // Mobile/tablet: 1 big square (1 column) — unchanged from before this pass.
      '<svg class="ai-view-toggle__icon-mobile" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16" aria-hidden="true">' +
      '<rect x="5" y="5" width="14" height="14" rx="2" stroke="currentColor" stroke-width="1.6"/>' +
      '</svg>' +
      // Desktop: 2x2 (2 columns, the "fewer/bigger" option — same glyph rhode's own catalog uses).
      '<svg class="ai-view-toggle__icon-desktop" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16" aria-hidden="true">' +
      '<rect x="4" y="4" width="7" height="7" rx="1.3" stroke="currentColor" stroke-width="1.6"/>' +
      '<rect x="13" y="4" width="7" height="7" rx="1.3" stroke="currentColor" stroke-width="1.6"/>' +
      '<rect x="4" y="13" width="7" height="7" rx="1.3" stroke="currentColor" stroke-width="1.6"/>' +
      '<rect x="13" y="13" width="7" height="7" rx="1.3" stroke="currentColor" stroke-width="1.6"/>' +
      '</svg>' +
      '</button>' +
      '<button type="button" class="ai-view-toggle__btn" data-view="double" aria-label="' + aiStr('morePerRow', 'Show more products per row') + '">' +
      // Mobile/tablet: 2x2 (2 columns) — unchanged from before this pass.
      '<svg class="ai-view-toggle__icon-mobile" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16" aria-hidden="true">' +
      '<rect x="4" y="4" width="7" height="7" rx="1.3" stroke="currentColor" stroke-width="1.6"/>' +
      '<rect x="13" y="4" width="7" height="7" rx="1.3" stroke="currentColor" stroke-width="1.6"/>' +
      '<rect x="4" y="13" width="7" height="7" rx="1.3" stroke="currentColor" stroke-width="1.6"/>' +
      '<rect x="13" y="13" width="7" height="7" rx="1.3" stroke="currentColor" stroke-width="1.6"/>' +
      '</svg>' +
      // Desktop: 3x3 (3 columns, the "more/smaller" option — same glyph rhode's own catalog uses).
      '<svg class="ai-view-toggle__icon-desktop" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="16" height="16" aria-hidden="true">' +
      '<rect x="4" y="4" width="4.5" height="4.5" rx="1" stroke="currentColor" stroke-width="1.5"/>' +
      '<rect x="9.75" y="4" width="4.5" height="4.5" rx="1" stroke="currentColor" stroke-width="1.5"/>' +
      '<rect x="15.5" y="4" width="4.5" height="4.5" rx="1" stroke="currentColor" stroke-width="1.5"/>' +
      '<rect x="4" y="9.75" width="4.5" height="4.5" rx="1" stroke="currentColor" stroke-width="1.5"/>' +
      '<rect x="9.75" y="9.75" width="4.5" height="4.5" rx="1" stroke="currentColor" stroke-width="1.5"/>' +
      '<rect x="15.5" y="9.75" width="4.5" height="4.5" rx="1" stroke="currentColor" stroke-width="1.5"/>' +
      '<rect x="4" y="15.5" width="4.5" height="4.5" rx="1" stroke="currentColor" stroke-width="1.5"/>' +
      '<rect x="9.75" y="15.5" width="4.5" height="4.5" rx="1" stroke="currentColor" stroke-width="1.5"/>' +
      '<rect x="15.5" y="15.5" width="4.5" height="4.5" rx="1" stroke="currentColor" stroke-width="1.5"/>' +
      '</svg>' +
      '</button>';
    countEl.parentElement.appendChild(toggle);

    var buttons = toggle.querySelectorAll('[data-view]');
    var RESIZE_DIM_MS = 400;

    function applyView(view, animate) {
      var grid = document.getElementById('product-grid');
      if (!grid) return;

      var before = grid.className;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!animate || reduceMotion) {
        // Applied with the cards' width transition suspended (the same class the animated path
        // uses): on first load the server renders the desktop/2-up markup and this then switches a
        // phone to 1 column — without this the cards visibly slid from half to full width.
        grid.classList.add('is-view-switching');
        applyColumnClasses(grid, view);
        syncButtons(view);
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            grid.classList.remove('is-view-switching');
          });
        });
        return;
      }

      var changed = (function () {
        applyColumnClasses(grid, view);
        return grid.className !== before;
      })();

      if (!changed) {
        syncButtons(view);
        return;
      }

      // Undo the class change just made above so the FLIP block below can redo it with a
      // "before" measurement in place first — applyColumnClasses already ran once here purely to
      // learn whether anything actually changed.
      grid.className = before;

      // FLIP (First-Last-Invert-Play): this grid is flexbox with flex-wrap, so a plain CSS width
      // transition on the cards isn't enough on its own — whether a second card actually fits
      // beside the first is a binary flex-wrap decision that flips abruptly *during* the width
      // transition, not a continuous one, so its position still snapped to the new line mid-
      // animation no matter how smooth the width easing was. Recording every card's real box
      // before the reflow, then playing a combined translate+scale from old to new via the Web
      // Animations API, sidesteps that: the card's own CSS width transition is suspended for this
      // one swap (#product-grid.is-view-switching) so WAAPI is the only thing moving it, and the
      // in-between flex-wrap states this technique glosses over never get a chance to show. This
      // same scale is also what hides the media's own instant aspect-ratio/height snap (see the
      // .ai-card-product__media-cardproductai comment in the section stylesheet) — no separate
      // opacity/blur treatment needed on it anymore, since the whole card (photo included) is
      // already scaling smoothly from its old size to its new one as one motion.
      var items = Array.prototype.slice.call(grid.querySelectorAll('.grid__item'));
      var firstRects = items.map(function (el) {
        return el.getBoundingClientRect();
      });

      grid.classList.add('is-view-switching');
      applyColumnClasses(grid, view);

      items.forEach(function (el, i) {
        var last = el.getBoundingClientRect();
        var first = firstRects[i];
        if (!last.width || !last.height) return;
        var dx = first.left - last.left;
        var dy = first.top - last.top;
        var sx = first.width / last.width;
        var sy = first.height / last.height;
        var unchanged = Math.abs(dx) < 1 && Math.abs(dy) < 1 && Math.abs(sx - 1) < 0.01 && Math.abs(sy - 1) < 0.01;
        if (unchanged || typeof el.animate !== 'function') return;
        // NOT the spring-overshoot curve the card's own hover/press feedback uses (that's for
        // quick tap feedback on one element) and NOT this site's own --expand-ease either (that's
        // for a panel folding/unfolding in place — a *height* change, not a card resizing and
        // repositioning at once). transitions-dev's own motion-token catalog names
        // cubic-bezier(0.22, 1, 0.36, 1) specifically for "resize, position change" — exactly this
        // case — over the more constant-velocity-through-the-middle feel of --expand-ease, which
        // read as closer to linear than eased for a move this size. Still the same family (a
        // smooth, no-overshoot ease), just the token suited to *this* category of motion rather
        // than expand/collapse's. Can't read it as a CSS custom property from this element (no
        // token for it is declared anywhere in scope, and .ai-card-product-cardproductai's own
        // --expand-* vars are on a descendant of .grid__item, which custom properties can't reach
        // upward through anyway) so the literal value is used directly.
        el.animate(
          [
            { transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(' + sx + ', ' + sy + ')' },
            { transform: 'translate(0px, 0px) scale(1, 1)' },
          ],
          { duration: RESIZE_DIM_MS, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
        );
      });

      window.setTimeout(function () {
        grid.classList.remove('is-view-switching');
      }, RESIZE_DIM_MS);

      syncButtons(view);
    }

    function syncButtons(view) {
      buttons.forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-view') === view);
      });
    }

    // Initial load applies whatever was saved (or the viewport-appropriate default) with no
    // animation — there's nothing on screen yet to transition from, so dimming here would just be
    // a pointless flash before first paint.
    applyView(getDefaultView(), false);

    // Re-run the exact same initial call one frame later. This looks redundant — isDesktopWidth()
    // already reads window.innerWidth directly, no matchMedia involved — but a real, reproduced
    // bug (reload a real desktop-width window with "fewer/2-col" saved, it silently lands on
    // mobile's 1-column instead) traced back to window.innerWidth itself occasionally not yet
    // reflecting the page's real, already-correct width the instant this deferred script's very
    // first synchronous tick runs — this early in the load sequence, at least in some
    // environments, it can still read a stale pre-layout value for one tick. Since is-single-col's
    // own CSS isn't gated behind any media query and carries a #id the desktop column-width rules
    // don't, one wrong read here is enough to strand the mobile class at any width until something
    // else (a resize, a click) corrects it — worth a guaranteed second, later-settled look rather
    // than trusting a single point-in-time read at the earliest possible moment.
    window.requestAnimationFrame(function () {
      applyView(getDefaultView(), false);
    });

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var view = btn.getAttribute('data-view');
        applyView(view, true);
        try {
          localStorage.setItem(viewStorageKey(), view);
        } catch (e) {
          // Private browsing / storage disabled — the toggle still works for this page view,
          // it just won't be remembered on the next visit.
        }
      });
    });

    // Same state, different meaning either side of the desktop breakpoint (applyColumnClasses) —
    // a live resize across it (not just a fresh page load at a given width) needs to re-apply the
    // saved view under its *new* interpretation, or a shopper who picked "fewer" on mobile and
    // then widens the window past 990px keeps whatever column classes were left over from mobile
    // instead of correctly landing on 2 columns.
    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        applyView(getDefaultView(), false);
      }, 150);
    });
  }
})();
